import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toArray from "@babel/runtime/helpers/toArray";
import { createSelector } from '@reduxjs/toolkit';
import { times } from '@beef/utils';
import { selectHeader, selectHeaderCommonData } from "../../common";
import { filterBySearchString } from "./utils";
export var selectRegionData = function selectRegionData(state) {
  return selectHeader(state).region || {};
};
export var selectCurrentUserRegion = function selectCurrentUserRegion(state) {
  return selectHeaderCommonData(state).currentRegion;
};
export var selectIsRegionModalOpen = function selectIsRegionModalOpen(state) {
  return selectRegionData(state).isRegionModalOpen;
};
export var selectAllRegions = function selectAllRegions(state) {
  return selectRegionData(state).allRegions;
};
export var selectSuggestionsRegions = function selectSuggestionsRegions(state) {
  return selectRegionData(state).suggestionsRegions;
};
export var selectFetchAllRegionsStatus = function selectFetchAllRegionsStatus(state) {
  return selectRegionData(state).fetchAllRegionsStatus;
};
export var selectFetchSuggestionsRegionsStatus = function selectFetchSuggestionsRegionsStatus(state) {
  return selectRegionData(state).fetchSuggestionsRegionsStatus;
};
export var selectSearchValue = function selectSearchValue(state) {
  return selectRegionData(state).searchValue;
};
export var selectCombinedRegions = createSelector(selectAllRegions, function (allRegions) {
  return allRegions.reduce(function (acc, cur) {
    return acc.concat(cur);
  }, []);
});
export var selectCartSuggestionsRegions = createSelector(selectCombinedRegions, selectSearchValue, function (_ref, searchValue) {
  var _ref2 = _toArray(_ref),
    _ = _ref2[0],
    regions = _ref2.slice(1);
  var regionsList = regions.reduce(function (acc, cur) {
    return acc.concat(cur.items);
  }, []);
  return regionsList.filter(filterBySearchString(searchValue));
});
export var selectPopularRegions = createSelector(selectCombinedRegions, function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 1),
    popularRegions = _ref4[0];
  return (popularRegions === null || popularRegions === void 0 ? void 0 : popularRegions.items) || [];
});
export var selectRegions = function selectRegions(columns) {
  return createSelector(selectCombinedRegions, function (_ref5) {
    var _ref6 = _toArray(_ref5),
      _ = _ref6[0],
      regions = _ref6.slice(1);
    var regionsPerColumn = regions.reduce(function (acc, regionGroup) {
      return acc + regionGroup.items.length;
    }, 0) / columns;
    var initialGroupedRegion = times(columns, function () {
      return [];
    });
    var currentColumn = 0;
    return regions.reduce(function (groupedRegions, currentRegionGroup) {
      if (groupedRegions[currentColumn].reduce(function (result, region) {
        return result + region.items.length;
      }, 0) >= regionsPerColumn && Array.isArray(groupedRegions[currentColumn + 1])) {
        currentColumn += 1;
        groupedRegions[currentColumn].push(currentRegionGroup);
        return groupedRegions;
      }
      groupedRegions[currentColumn].push(currentRegionGroup);
      return groupedRegions;
    }, initialGroupedRegion);
  });
};